import React from "react";
import { BoxProps } from "@mui/material";
import { Replace, Undo } from "lucide-react";
import CalloutContainer from "./CalloutContainer";
import { CalloutStates } from "../new-editor/elements/Callout";

export enum CalloutStatus {
  SYNC = "Sync",
  UNDO = "Undo",
}

interface DefaultSettingsCalloutProps extends BoxProps {
  onClick?: () => void;
  status: CalloutStatus;
  text: React.ReactNode;
  className?: string;
  calloutState?: CalloutStates;
}

const DefaultSettingsCallout = ({
  onClick,
  status,
  text,
  className,
  calloutState = CalloutStates.SUCCESS,
}: DefaultSettingsCalloutProps) => {
  const buttonValues = {
    icon: status === CalloutStatus.SYNC ? Replace : Undo,
    text: status,
  };

  return (
    <CalloutContainer
      onClick={onClick}
      text={text}
      calloutButton={buttonValues}
      calloutState={calloutState}
      className={className}
    />
  );
};

export default DefaultSettingsCallout;
